"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.desktop = exports.tablet = exports.mobile = void 0;
exports.mobile = 375;
exports.tablet = 768;
exports.desktop = 1024;
const viewportWidths = [exports.mobile, exports.tablet, exports.desktop];
exports.default = viewportWidths;
